// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ConfirmModal.css */

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 150ms ease;
}

.modal-content {
  background: #fff;
  border-radius: var(--radius-lg, 0.75rem);
  padding: 1.5rem;
  max-width: 400px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: var(--shadow-xl, 0 20px 25px -5px rgba(0,0,0,0.1));
  animation: slideUp 200ms ease;
}

.modal-content h3 {
  margin: 0 0 0.5rem;
  font-size: 1.1rem;
  color: #111827;
}

.modal-content p {
  margin: 0 0 1.25rem;
  color: #4b5563;
  font-size: 0.95rem;
  line-height: 1.5;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
}

.modal-btn {
  padding: 0.6rem 1.25rem;
  border: none;
  border-radius: var(--radius-md, 0.5rem);
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 150ms;
  font-family: inherit;
}

.modal-btn-cancel {
  background: var(--gray-200, #e5e7eb);
  color: var(--gray-700, #374151);
}
.modal-btn-cancel:hover {
  background: var(--gray-300, #d1d5db);
}

.modal-btn-danger {
  background: #ef4444;
  color: #fff;
}
.modal-btn-danger:hover {
  background: #dc2626;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to   { opacity: 1; }
}

@keyframes slideUp {
  from { transform: translateY(20px); opacity: 0; }
  to   { transform: translateY(0); opacity: 1; }
}

/* Mobile */
@media (max-width: 767px) {
  .modal-content {
    padding: 1.25rem;
    width: 92%;
  }
  .modal-content h3 { font-size: 1rem; }
  .modal-btn {
    padding: 0.6rem 1rem;
    font-size: 0.85rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/dashboard/ConfirmModal.css"],"names":[],"mappings":"AAAA,qBAAqB;;AAErB;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,8DAA8D;EAC9D,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,uCAAuC;EACvC,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,+BAA+B;AACjC;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,OAAO,wBAAwB,EAAE,UAAU,EAAE;AAC/C;;AAEA,WAAW;AACX;EACE;IACE,gBAAgB;IAChB,UAAU;EACZ;EACA,oBAAoB,eAAe,EAAE;EACrC;IACE,oBAAoB;IACpB,kBAAkB;EACpB;AACF","sourcesContent":["/* ConfirmModal.css */\n\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  animation: fadeIn 150ms ease;\n}\n\n.modal-content {\n  background: #fff;\n  border-radius: var(--radius-lg, 0.75rem);\n  padding: 1.5rem;\n  max-width: 400px;\n  width: 90%;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: var(--shadow-xl, 0 20px 25px -5px rgba(0,0,0,0.1));\n  animation: slideUp 200ms ease;\n}\n\n.modal-content h3 {\n  margin: 0 0 0.5rem;\n  font-size: 1.1rem;\n  color: #111827;\n}\n\n.modal-content p {\n  margin: 0 0 1.25rem;\n  color: #4b5563;\n  font-size: 0.95rem;\n  line-height: 1.5;\n}\n\n.modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n}\n\n.modal-btn {\n  padding: 0.6rem 1.25rem;\n  border: none;\n  border-radius: var(--radius-md, 0.5rem);\n  font-size: 0.9rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 150ms;\n  font-family: inherit;\n}\n\n.modal-btn-cancel {\n  background: var(--gray-200, #e5e7eb);\n  color: var(--gray-700, #374151);\n}\n.modal-btn-cancel:hover {\n  background: var(--gray-300, #d1d5db);\n}\n\n.modal-btn-danger {\n  background: #ef4444;\n  color: #fff;\n}\n.modal-btn-danger:hover {\n  background: #dc2626;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n\n@keyframes slideUp {\n  from { transform: translateY(20px); opacity: 0; }\n  to   { transform: translateY(0); opacity: 1; }\n}\n\n/* Mobile */\n@media (max-width: 767px) {\n  .modal-content {\n    padding: 1.25rem;\n    width: 92%;\n  }\n  .modal-content h3 { font-size: 1rem; }\n  .modal-btn {\n    padding: 0.6rem 1rem;\n    font-size: 0.85rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
